module.exports = __webpack_public_path__ + "img/1458838540.968368b7.jpg";